import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormGroup,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Switch from "react-switch"
import { Offsymbol, OnSymbol } from "util/switchButtonUtil"
// import CustomSelect from "../../components/CustomSelect/customSelect"
// import MultiSelectSort from "components/SortableSelect/SortableSelect"
import _ from "lodash"
import ValidatorForm, { TextField, MultiSelect } from "../ValidatorForm"
import Select from "react-select"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import { LANGUAGES, PERMISSIONS_ARRAY } from "../../constants/uiConstants"
import "./styles.css"
export default class CreateAppUserForm extends ErrorBoundComponent {
  state = {
    formData: {},
    appCode: this.props.appCode,
    status:
      this.props && this.props.data && this.props.data.status === 0
        ? false
        : true,
    domainArray: [
      { label: "techugo.com", value: "techugo.com" },
      { label: "eternoinfotech.in", value: "eternoinfotech.in" },
      { label: "dailyhunt.in", value: "dailyhunt.in" },
      { label: "verse.in", value: "verse.in" },
    ],
    agency: null,
    customStyles: {
      option: (provided, state) => ({
        ...provided,
        color: "black",
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "black",
      }),
    },
  }

  componentDidMount() {
    const { permissionList = [], roleData = [] } = this.props
    const permissionArray = []
    permissionList.map((item, idx) => {
      let label = item.permissionId.split("_").toString()
      let permissionObj = {
        label: label.replaceAll(",", " "),
        value: item.permissionId,
      }
      permissionArray.push(permissionObj)
    })
    const rolesArray = []
    roleData.map((item, idx) => {
      let roleObj = {
        label: item.roleName,
        value: item.roleCode,
      }
      rolesArray.push(roleObj)
    })

    this.setState({ permissionArray, rolesArray })
  }

  _handleFieldChange = (val, field) => {
    let formData = this.state.formData
    if (field === "domain") {
      formData[field] = val.value
    }
    this.setState({
      formData,
    })
  }

  _getDefaultValues = (roles, field) => {
    // let applicationsData = applications.filter((item) => item.applicationCode === this.state.appCode);
    // let filteredApp = applicationsData && applicationsData.length>0 ? applicationsData[0] : {};
    // let rolesArr = !_.isEmpty(filteredApp) ? (filteredApp["roles"] && filteredApp["roles"].length > 0 ?  filteredApp["roles"] : []) : [];
    let array = []
    let roleOrPermissionArr = []
    switch (field) {
      case "roles":
        roleOrPermissionArr = this.state.rolesArray
        break
      case "includePermission":
      case "excludePermission":
        roleOrPermissionArr = this.state.permissionArray
        break
    }
    roleOrPermissionArr.forEach(item => {
      if (roles.includes(item.value)) {
        array.push(item)
      }
    })
    return array
  }

  _form = () => {
    const { permissionList = [] } = this.props

    const filterdPermissions = PERMISSIONS_ARRAY.map(permission => {
      if (
        permission.value === "UPDATE_USER_AGENCY" &&
        !this.props.currentUser?.jotRoles?.includes("SUPER_ADMIN")
      ) {
        return { ...permission, disabled: true }
      } else {
        return permission
      }
    })
    // const permissionArray =  [];
    // const filterdPermissions = permissionList.map((item, idx) => {
    //   let label = (item.permissionId.split("_")).toString();
    //   let permissionObj = {
    //     label: label.replaceAll(",", " "),
    //     value: item.permissionId
    //   }
    //   permissionArray.push(permissionObj);
    //   // return permissionArray;
    // })
    // const permissionArray = [
    //   ...PERMISSIONS_ARRAY,
    //   // {
    //   //   label: "Internal QC Tag Content",
    //   //   value: "INTERNAL_QC_TAG_CONTENT",
    //   //   disabled:
    //   //     this.props.currentUser.agency ||
    //   //     (this.props.currentUser.agency &&
    //   //       !this.props.currentUser.agency.includes("INTERNAL")),
    //   // },
    //   {
    //     label: "Tag Content Admin",
    //     value: "TAG_CONTENT_ADMIN",
    //     disabled: this.props.currentUser.userType > 1
    //   },
    //   {
    //     label: "Community Manager",
    //     value: "COMMUNITY_MANAGER",
    //     disabled: this.props.currentUser.userType > 1
    //   },
    //   {
    //     label: "View Real Stats",
    //     value: "VIEW_REAL_STATS",
    //     disabled: thi <Modal show={props.show} onHide={props.onClose} centered>
    // ];
    return (
      <React.Fragment>
        <Col>
          <Card>
            <CardTitle className="p-3 pb-0">
              {this.props.formAction === "create"
                ? "Create User"
                : "Update User"}
            </CardTitle>
            <CardBody>
              <AvForm onValidSubmit={(e, values) => this._onSubmit(values)}>
                <Row>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="name" className="col-lg-2">
                        Full Name
                      </Label>
                      <AvField
                        name="name"
                        type="text"
                        defaultValue={this.props.data && this.props.data.name}
                        errorMessage="Provide Name"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="email" className="col-lg-2">
                        Email
                      </Label>
                      <AvField
                        name="email"
                        placeholder="Enter Valid Email"
                        type="email"
                        errorMessage="Invalid Email"
                        validate={{
                          required: { value: true },
                          email: { value: true },
                        }}
                        defaultValue={this.props.data && this.props.data.email}
                        //disabled={this.props.formAction === "create" ? false : true}
                      />
                    </FormGroup>
                  </Col>
                  {this.props.formAction === "create" && (
                    <Col lg="12">
                      <FormGroup className="mb-2">
                        <Label htmlFor="password" className="col-lg-2">
                          Password
                        </Label>
                        <AvField
                          name="password"
                          type="password"
                          placeholder="Password"
                          errorMessage="Enter password"
                          autoComplete="off"
                          validate={{
                            required: {
                              value:
                                this.props.formAction === "create"
                                  ? true
                                  : false,
                            },
                          }}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {/* <Col lg="12">
                    <FormGroup className="mb-2">
                      <Label htmlFor="domain">Domain</Label>
                      <Select
                        isMulti={false}
                        styles={this.state.customStyles}
                        onChange={val => this._handleFieldChange(val, "domain")}
                        defaultValue={
                          this.props.data &&
                          this.props.data.domain &&
                          this._getDefaultValues(
                            this.props.data.domain,
                            "domain"
                          )
                        }
                        options={this.state.domainArray}
                        //isOptionDisabled={option => option.disabled}
                      />
                    </FormGroup>
                  </Col> */}
                  <Col lg="6">
                    <FormGroup className="mb-2">
                      <Label htmlFor="userStatus" className="col-lg-4">
                        Status
                      </Label>
                      <Col lg="10">
                        <Switch
                          uncheckedIcon={<Offsymbol />}
                          checkedIcon={<OnSymbol />}
                          className="me-1 mb-sm-8 mb-2"
                          onColor="#626ed4"
                          onChange={() =>
                            this.setState({ status: !this.state.status })
                          }
                          checked={this.state.status}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end">
                  <Button type="submit" color="primary" className="mx-2">
                    {this.props.formAction === "create" ? "Create" : "Update"}
                  </Button>
                  <Button color="danger" onClick={this.props.onCancel}>
                    Cancel
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }

  _onSubmit = formData => {
    const {
      includePermission = [],
      excludePermission = [],
      roles = [],
      //domain,
    } = this.state.formData

    formData.status = this.state.status ? 1 : 0
    //formData.roles = !_.isEmpty(roles) ? JSON.stringify(roles) : null

    formData.email = formData.email.toLowerCase()

    const data = new FormData()
    if (!_.isEmpty(formData.name)) {
      data.append("name", formData.name)
    }
    data.append("status", this.state.status ? 1 : 0)
    // if (!_.isEmpty(formData.status)) {
    //   data.append("status", formData.status)
    // }
    if (!_.isEmpty(formData.password)) {
      data.append("password", formData.password)
    }
    if (!_.isEmpty(formData.email)) {
      data.append("email", formData.email)
    }
    if (!_.isEmpty(includePermission)) {
      data.append("includePermission", JSON.stringify(includePermission))
    }
    // if (!_.isEmpty(domain)) {
    //   data.append("domain", domain)
    // }
    if (!_.isEmpty(excludePermission)) {
      data.append("excludePermission", JSON.stringify(excludePermission))
    }
    if (!_.isEmpty(roles)) {
      data.append("roles", JSON.stringify(roles))
    }
    // Object.keys(this.state.formData).forEach(key => {
    //   if (
    //     this.state.formData[key] !== undefined &&
    //     this.state.formData[key] !== ""
    //   ) {
    //     data.append(key, this.state.formData[key])
    //   }
    // })
    // var data = _.omitBy(formData, _.isNil)
    // data.includePermission = !_.isEmpty(includePermission)
    //   ? JSON.stringify(includePermission)
    //   : JSON.stringify([])
    // data.excludePermission = !_.isEmpty(excludePermission)
    //   ? JSON.stringify(excludePermission)
    //   : JSON.stringify([])
    this.props.onSubmit(data)
  }

  _render = () => {
    return this._form()
  }
}
